<template>
  <div class="plans">
    <h1>考试记录</h1>
    <div class="content">
      <div class="allsocre">
        <p class="scoreinfo">计算机科学与技术（2020上）考试记录</p>
      </div>
      <table  class="table table-bordered">
        <tr>
          <td class="infobg" width="10%" >提交日期</td>
          <td class="infobg" width="10%">操作</td>
        </tr>
        <tr>
          <td>2019-06-28 17:56:40</td>
          <td><button class="btn">删除</button></td>
        </tr>
        <tr>
          <td>2019-06-28 17:56:40</td>
          <td><button class="btn">删除</button></td>
        </tr>
        <tr>
          <td>2019-06-28 17:56:40</td>
          <td><button class="btn">删除</button></td>
      </tr>
        <tr>
          <td>2019-06-28 17:56:40</td>
          <td><button class="btn">删除</button></td>
        </tr>
        <tr>
          <td>2019-06-28 17:56:40</td>
          <td><button class="btn">删除</button></td>
        </tr>
        <tr>
          <td>2019-06-28 17:56:40</td>
          <td><button class="btn">删除</button></td>
        </tr>

      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlanList',
  data: function () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/mixins.styl'
  .plans{
    margin-bottom:30px;
    h1{
      font-size:16px;
      font-weight:bold;
      margin-bottom:20px;
    }
    .content{
      background:#fff;
      padding:28px;
      .liinfo{

      }
      .li-top{
        font-size:16px;
        font-weight:bold;
        color:$bgColor;
        margin-bottom:20px;
      }
      .table td{
        background:#fff;
        text-align:center;
        &.infobg{
          background:$bgColor;
          font-weight:bold;
          color:#fff;
        }
      }
      .scorename{
        font-size:34px;
        text-align:center;
        line-height:56px;
        background:url("../../../assets/images/hg.png") no-repeat center 10px;
      }
      .allsocre{
        background:$bgcontent;
        padding:28px;
        margin-bottom:30px;
      }
      .scoreinfo{
         text-align:center;
         font-weight:bold;
      }
    }
  }
  .btn{
    padding:6px 16px;
    background:$bgColor;
    color:#fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/submissionrecords/components/PlanList.vue